// utils/uploadRequest.js
import axios from 'axios'

const uploadRequest = axios.create({
  baseURL: process.env.NODE_ENV !== 'production'
    ? process.env.VUE_APP_BASE_API
    : process.env.VUE_APP_SERVER_URL,
  timeout: 60000 // 文件上传通常需要更长的超时时间
})

// ⚠️ 不添加任何 request/response 拦截器
// ⚠️ 不设置默认 Content-Type

export default uploadRequest
